import { format, formatDistance, formatRelative } from 'date-fns';
import { enUS } from 'date-fns/locale';
import { toZonedTime } from 'date-fns-tz';

export default function formatRelativeDistanceToNow(inputDate: string | Date, now: Date, timeZone: string, locale = enUS) {
    const date = typeof inputDate === 'string' ? new Date(inputDate) : inputDate;
    const zoned = toZonedTime(date, timeZone);
    const nowZoned = toZonedTime(now, timeZone);

    const daysDiff = Math.floor((+nowZoned - +zoned) / (1000 * 60 * 60 * 24));
    const hoursDiff = Math.floor((+nowZoned - +zoned) / (1000 * 60 * 60));

    if (hoursDiff <= 3) {
        return formatDistance(zoned, nowZoned, { addSuffix: true, locale });
    }

    if (daysDiff < 7) {
        return formatRelative(zoned, nowZoned, { locale });
    }

    if (nowZoned.getFullYear() === zoned.getFullYear()) {
        return format(zoned, 'MMMM d', { locale });
    }

    return format(zoned, 'MMMM d, yyyy', { locale });
}
